import { render, staticRenderFns } from "./CmgIneligibleOrderCard.vue?vue&type=template&id=593fd656&scoped=true&lang=pug"
import script from "./cmg-ineligible-order-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ineligible-order-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIneligibleOrderCard.vue?vue&type=style&index=0&id=593fd656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593fd656",
  null
  
)

export default component.exports